import * as React from "react";

export const Checkmark = () => (
    <svg
        // xmlns:dc="http://purl.org/dc/elements/1.1/"
        // xmlns:cc="http://creativecommons.org/ns#"
        // xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        // xmlns:svg="http://www.w3.org/2000/svg"
        // xmlns="http://www.w3.org/2000/svg"
        // xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        // xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        version="1.1"
        viewBox="0 0 100 100"
        enableBackground="new 0 0 129 129"
        // id="svg10"
        // sodipodi:docname="correct.svg"
        width="100"
        height="100"
        className="list-icon"
        // inkscape:version="0.92.1 r15371"
    >
        {/* <metadata
      id="metadata16">
     <rdf:RDF>
       <cc:Work
          rdf:about="">
         <dc:format>image/svg+xml</dc:format>
         <dc:type
            rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
         <dc:title></dc:title>
       </cc:Work>
     </rdf:RDF>
   </metadata>
   <defs
      id="defs14" />
   <sodipodi:namedview
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1"
      objecttolerance="10"
      gridtolerance="10"
      guidetolerance="10"
      inkscape:pageopacity="0"
      inkscape:pageshadow="2"
      inkscape:window-width="1920"
      inkscape:window-height="1057"
      id="namedview12"
      showgrid="false"
      showguides="false"
      inkscape:zoom="2.9662736"
      inkscape:cx="-47.136643"
      inkscape:cy="43.109811"
      inkscape:window-x="1912"
      inkscape:window-y="-8"
      inkscape:window-maximized="1"
      inkscape:current-layer="g8" /> */}
        <g
            id="g8"
            transform="matrix(0.86077654,0,0,0.86077654,-5.4918508,-5.5312036)"
            //   style="stroke-width:1.16174173"
        >
            <g
                id="g6"
                // style="stroke-width:1.16174173"
            >
                <path
                    d="m 40.5,61.1 c -1.6,-1.6 -4.2,-1.6 -5.8,0 -1.6,1.6 -1.6,4.2 0,5.8 l 18.9,18.9 c 0.8,0.8 1.8,1.2 2.9,1.2 0.1,0 0.1,0 0.2,0 1.1,-0.1 2.2,-0.6 3,-1.5 L 107,28.8 c 1.4,-1.7 1.2,-4.3 -0.5,-5.8 -1.7,-1.4 -4.3,-1.2 -5.8,0.5 L 56.2,76.8 Z"
                    id="path1"
                    //   inkscape:connector-curvature="0"
                    //   style="stroke-width:1.16174173"
                />
                <path
                    d="M 95.1,15.3 C 72.1,0.9 42.6,4.3 23.4,23.5 0.8,46.1 0.8,83 23.4,105.6 c 11.3,11.3 26.2,17 41,17 14.8,0 29.7,-5.7 41,-17 19.3,-19.3 22.6,-48.9 8.1,-71.9 -1.2,-1.9 -3.7,-2.5 -5.6,-1.3 -1.9,1.2 -2.5,3.7 -1.3,5.6 12.5,19.8 9.6,45.2 -7,61.8 -19.4,19.4 -51.1,19.4 -70.5,0 C 9.7,80.4 9.7,48.7 29.1,29.3 45.7,12.8 71,9.9 90.8,22.2 c 1.9,1.2 4.4,0.6 5.6,-1.3 1.2,-1.9 0.6,-4.4 -1.3,-5.6 z"
                    id="path2"
                    //   inkscape:connector-curvature="0"
                    //   style="stroke-width:1.16174173"
                />
            </g>
        </g>
    </svg>
);
